import React, { useState, FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

// components
import Contact1stdibsModalLazy from './Contact1stdibsModalLazy';

// helpers
import { trackEvent } from 'dibs-tracking';

import styles from '../Footer/LinkColumn/LinkColumnItem.scss';

type Props = {
    trackingLabel: string;
};

const Contact1stdibsFooterLink: FunctionComponent<Props> = ({ trackingLabel }) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const trackClick = (): void => {
        trackEvent({
            category: 'navigation',
            action: 'footer navigation click',
            label: trackingLabel.trim().toLowerCase(),
        });
    };

    return (
        <li
            className={styles.item}
            onClick={() => {
                setIsContactModalOpen(true);
                trackClick();
            }}
        >
            <div className={styles.contact1stdibsLink}>
                <FormattedMessage
                    id="dbl.Footer.site_links_contact_1stdibs"
                    defaultMessage="Contact 1stdibs"
                />
            </div>
            <Contact1stdibsModalLazy
                isOpen={isContactModalOpen}
                placement="globalFooter"
                onClose={() => setIsContactModalOpen(false)}
            />
        </li>
    );
};

export default Contact1stdibsFooterLink;
